export default __webpack_public_path__ + "static/media/NABL.00d026cb.png";